<template>
	<v-text-field :is="tagName"
		v-model.trim="model"
		:name="name"
		:label="label"
		:required="required"
		:counter="counter"
		ref="input"
		v-bind="$attrs"
		v-validate="ruleString"
		:error-messages="errors.collect(label)"
		:data-vv-name="label"
		:clearable="clearable&&!required"
		@change="$emit('change',model)"
	>
		<template v-slot:append>
			<v-icon x-small v-if="required" color="red lighten-2">mdi-asterisk</v-icon>
		</template>
	</v-text-field>
</template>

<script>
	export default {
		$_veeValidate: {
			validator: "new",
			name() {
				return this.label;
			},
			value() {
				return this.$refs.input.value;
			}
		},
		name: "smart-input",
		props: {
			label: {type: String},
			value: {},
			name: {type: String},
			rules: {type: String},
			clearable: {type: Boolean, default: true},
			required: {type: Boolean},
			textarea: {
				type: Boolean, default: false
			}
		},
		components: {},
		data() {
			return {};
		},
		methods: {
			getAttrsRule(attrs) {
				let validAttrs = ["minlength", "maxlength", "min", "max"];
				const dic = {"minlength": "min", "maxlength": "max"};
				const numberDic = {
					"minlength": "min",
					"maxlength": "max",
					"min": "min_value",
					"max": "max_value"
				};
				let rules = [this.rules];
				Object.keys(attrs).forEach((rule) => {
					if (validAttrs.indexOf(rule) > -1) {
						let key = dic[rule] || rule;
						if (this.type === "number") {
							key = numberDic[rule] || rule;
						}
						rules.push(`${key}:${attrs[rule]}`);
					}
				});
				return rules.join("|");

			}
		},
		computed: {
			type() {
				return this.$attrs.type || "text";
			},
			counter() {
				return (this.$attrs.maxlength) ? +this.$attrs.maxlength : null;
			},
			model: {
				get() {
					return this.value;
				},
				set(val) {
					this.$emit("input", val);
				}
			},
			theLabel() {
				return (this.required ? "* " : "") + this.label;
			},
			ruleString() {
				let rules = [];
				if (this.required) {
					rules.push("required");
				}
				if (this.type === "email") {
					rules.push("email");
				}
				let attrs = this.getAttrsRule(this.$attrs);
				if (attrs) {
					rules.push(attrs);
				}
				return rules.join("|");
			},
			tagName() {
				if (this.type === "checkbox") {
					return "v-checkbox";
				} else if (this.type === "radio") {
					return "v-radio";
				}
				return this.textarea ? "v-textarea" : "v-text-field";
			}

		}

	};
</script>

